export default "/images/ic_favorite_outline.svg?4a5fa2bcc2cd5414fe32bc6f61f34b74";